import { FailedSolutionIdExchange } from '~/modules/utilities/exceptions/FailedSolutionIdExchange';
import { getPackageSolutionId, getTrialTemplateSolutionId } from '../services/solutionsService';
import { forceListingStore, selectSolutionExtensionData } from '../stores/listings/forceListingStore';
import { listingStore, selectTrialTemplate } from '../stores/listings/listingStore';
import { navigate, SECURITY_REVIEW_EDITOR_ROUTE } from '../stores/routerStore';
import { isApiSolutionType, isNonForcePackageSolutionType, TECHNOLOGY_SOLUTION_MAP } from './schemaUtilities';
import { OpsSecurityOpsReviewStatus, PartnerSecurityReviewStatus } from './securityReviewUtilities';
export function createSolutionBootstrapper(labels) {
  var _technologyBaseBootst, _technologyBaseBootst2, _technologyBaseBootst3;
  const technologyBaseBootstrap = {
    initial: {
      mainLabels: labels.bootStrapper.initial.main,
      type: 'selection',
      selections: [{
        previewLabels: labels.bootStrapper.packageSolution.preview,
        value: 'packageSolution',
        iconName: 'bootstrapper:package',
        class: 'blue'
      }, {
        previewLabels: labels.bootStrapper.apiSolution.preview,
        value: 'apiSolution',
        iconName: 'bootstrapper:package',
        class: 'blue'
      }, {
        previewLabels: labels.bootStrapper.sfdcTrial.preview,
        value: 'sfdcTrial',
        iconName: 'bootstrapper:api',
        class: 'blue'
      }]
    },
    packageSolution: {
      mainLabels: labels.bootStrapper.packageSolution.main,
      type: 'selection',
      selections: [{
        previewLabels: labels.bootStrapper['force/Package'].preview,
        value: 'force/Package',
        iconName: 'product:sfdc'
      }, {
        previewLabels: labels.bootStrapper['quip/Package'].preview,
        value: 'quip/Package',
        iconName: 'product:quip'
      }, {
        previewLabels: labels.bootStrapper['b2c/Package'].preview,
        value: 'b2c/Package',
        iconName: 'product:commerce'
      }]
    },
    apiSolution: {
      mainLabels: labels.bootStrapper.apiSolution.main,
      type: 'selection',
      selections: [{
        previewLabels: labels.bootStrapper['force/Api'].preview,
        value: 'force/Api',
        iconName: 'product:sfdc'
      }, {
        previewLabels: labels.bootStrapper['marketing-cloud/Api'].preview,
        value: 'marketing-cloud/Api',
        iconName: 'product:marketing'
      }, {
        previewLabels: labels.bootStrapper['b2c/Api'].preview,
        value: 'b2c/Api',
        iconName: 'product:commerce'
      }]
    },
    sfdcTrial: {
      mainLabels: labels.bootStrapper.connectOrg.main,
      type: 'connectOrg'
    },
    sfdcOrg: {
      mainLabels: labels.bootStrapper.connectOrg.main,
      type: 'connectOrg'
    },
    'force/Package': {
      mainLabels: labels.bootStrapper.connectOrg.main,
      type: 'connectOrg'
    },
    'force/Api': {
      mainLabels: labels.bootStrapper['force/Api'].main,
      type: 'connectApi'
    },
    'quip/Package': {
      mainLabels: labels.bootStrapper['quip/Package'].main,
      type: 'connectUrl'
    },
    'b2c/Api': {
      mainLabels: labels.bootStrapper['b2c/Api'].main,
      type: 'connectApi'
    },
    'b2c/Package': {
      mainLabels: labels.bootStrapper['b2c/Package'].main,
      type: 'connectUrl'
    },
    'marketing-cloud/Api': {
      mainLabels: labels.bootStrapper['marketing-cloud/Api'].main,
      type: 'connectApi'
    },
    'tableau/Accelerator': {
      mainLabels: labels.bootStrapper['tableau/Accelerator'].main,
      type: 'connectUrl'
    }
  };
  (_technologyBaseBootst = technologyBaseBootstrap.initial) === null || _technologyBaseBootst === void 0 ? void 0 : (_technologyBaseBootst2 = _technologyBaseBootst.selections) === null || _technologyBaseBootst2 === void 0 ? void 0 : _technologyBaseBootst2.push({
    previewLabels: labels.bootStrapper.sfdcOrg.preview,
    value: 'sfdcOrg',
    iconName: 'bootstrapper:consultant',
    class: 'blue'
  });
  (_technologyBaseBootst3 = technologyBaseBootstrap.packageSolution.selections) === null || _technologyBaseBootst3 === void 0 ? void 0 : _technologyBaseBootst3.push({
    previewLabels: labels.bootStrapper['tableau/Accelerator'].preview,
    value: 'tableau/Accelerator',
    iconName: 'product:tableau'
  });
  return technologyBaseBootstrap;
}
export async function getTemplateId() {
  const {
    selectedTrialTemplateId
  } = forceListingStore.getState();
  const trialTemplate = selectTrialTemplate(listingStore.getState());
  if (selectedTrialTemplateId === trialTemplate.solutionId) {
    return undefined;
  }
  if (!selectedTrialTemplateId) {
    return undefined;
  }
  const {
    id
  } = await getTrialTemplateSolutionId(selectedTrialTemplateId);
  if (!id) {
    throw new FailedSolutionIdExchange('Failed to exchange trialTemplateId for solutionId');
  }
  return id;
}
export async function getSolutionId(listingType) {
  const {
    selectedSolutionId,
    selectedPackageVersionId
  } = forceListingStore.getState();
  const solution = selectSolutionExtensionData(forceListingStore.getState());
  if (selectedSolutionId === solution.solutionId) {
    return undefined;
  }
  if (!selectedPackageVersionId) {
    return undefined;
  }
  if (TECHNOLOGY_SOLUTION_MAP[listingType] !== 'force/Package') {
    throw new FailedSolutionIdExchange(`Attempting to exchange packageVersionId for solutionId for a listing of type '${listingType}' that should not have packages`);
  }
  const {
    id
  } = await getPackageSolutionId(selectedPackageVersionId);
  if (!id) {
    throw new FailedSolutionIdExchange('Failed to exchange packageVersionId for solutionId');
  }
  return id;
}
export async function retrievePackageSolutionId(packageVersionId) {
  const {
    id
  } = await getPackageSolutionId(packageVersionId);
  if (!id) {
    throw new FailedSolutionIdExchange('Failed to exchange packageVersionId for solutionId');
  }
  return id;
}
export function selectSolutionName(solution) {
  if (isApiSolutionType(solution.technology) || isNonForcePackageSolutionType(solution.technology)) {
    return solution.solution.name || '';
  }
  const packageSolution = solution.solution;
  return `${packageSolution.version.majorVersion}.${packageSolution.version.minorVersion}.${packageSolution.version.patchVersion}`;
}
function isSubbmitedAndReturned(partnerSRStatus, opsSRStatus) {
  return (partnerSRStatus === PartnerSecurityReviewStatus.submitted || partnerSRStatus === PartnerSecurityReviewStatus.reSubmitted) && (opsSRStatus === OpsSecurityOpsReviewStatus.returnedOps || opsSRStatus === OpsSecurityOpsReviewStatus.returnedProdSec);
}
export function isEditable(partnerSRStatus, opsSRStatus) {
  return partnerSRStatus === PartnerSecurityReviewStatus.new || partnerSRStatus === PartnerSecurityReviewStatus.revoked || opsSRStatus && isSubbmitedAndReturned(partnerSRStatus, opsSRStatus);
}
export function canResubmit(hasFalsePositiveDoc, opsSRStatus) {
  return opsSRStatus === OpsSecurityOpsReviewStatus.failedTest && hasFalsePositiveDoc;
}
function isFinalState(opsSRStatus) {
  return opsSRStatus === OpsSecurityOpsReviewStatus.pass || opsSRStatus === OpsSecurityOpsReviewStatus.failedTest;
}
function isReturned(opsSRStatus) {
  return opsSRStatus === OpsSecurityOpsReviewStatus.returnedProdSec || opsSRStatus === OpsSecurityOpsReviewStatus.returnedOps;
}
function isExpired(opsSRStatus) {
  return opsSRStatus === OpsSecurityOpsReviewStatus.expired;
}
export function getSecurityReviewLink(solution) {
  if (!isApiSolutionType(solution.technology) && !isNonForcePackageSolutionType(solution.technology)) {
    const packageVersionId = solution.solution.version.packageVersionId;
    return `${SECURITY_REVIEW_EDITOR_ROUTE}?packageVersionId=${packageVersionId}`;
  }
  return `${SECURITY_REVIEW_EDITOR_ROUTE}?solutionId=${solution.id}`;
}
export function calculateSecurityReviewLink(solutionWithReviews, labels) {
  var _withVersion$version, _withVersion$version2, _solutionWithReviews$, _solutionWithReviews$3, _solutionWithReviews$5, _solutionWithReviews$6, _solutionWithReviews$7;
  const withVersion = solutionWithReviews === null || solutionWithReviews === void 0 ? void 0 : solutionWithReviews.solution;
  const isPatch = withVersion === null || withVersion === void 0 ? void 0 : (_withVersion$version = withVersion.version) === null || _withVersion$version === void 0 ? void 0 : _withVersion$version.patchVersion;
  if (withVersion !== null && withVersion !== void 0 && (_withVersion$version2 = withVersion.version) !== null && _withVersion$version2 !== void 0 && _withVersion$version2.versionOptionsSecurityReviewed && !(solutionWithReviews !== null && solutionWithReviews !== void 0 && solutionWithReviews.securityReview)) {
    // Solution Version was already reviewed in TZ but oaf doesn't have a record for it.
    return {
      text: labels.requestReReview,
      icon: '',
      onclick: function () {
        navigate(getSecurityReviewLink(solutionWithReviews));
      },
      statusText: '',
      showIcon: true,
      infoBubble: labels.initiateReReviewInfoBubble,
      showReReviewModal: true
    };
  }
  if (!solutionWithReviews.securityReview) {
    if (isPatch) {
      // Requesting to review a patch version, show warning modal.
      return {
        text: labels.securityReviewLinkStart,
        icon: '',
        onclick: function () {
          navigate(getSecurityReviewLink(solutionWithReviews));
        },
        statusText: '',
        showIcon: false,
        showPatchVersionModal: true
      };
    }
    return {
      text: labels.securityReviewLinkStart,
      href: getSecurityReviewLink(solutionWithReviews),
      icon: '',
      statusText: '',
      showIcon: false
    };
  } else if (isEditable(solutionWithReviews.securityReview.status, (_solutionWithReviews$ = solutionWithReviews.securityReviewFeedback) === null || _solutionWithReviews$ === void 0 ? void 0 : _solutionWithReviews$.status)) {
    var _solutionWithReviews$2;
    if (isReturned((_solutionWithReviews$2 = solutionWithReviews.securityReviewFeedback) === null || _solutionWithReviews$2 === void 0 ? void 0 : _solutionWithReviews$2.status)) {
      //TODO: for review returned we should also send them to the step that has the feedback from Ops/Prodsec
      return {
        text: labels.checkReviewStatusLinkStart,
        href: `${SECURITY_REVIEW_EDITOR_ROUTE}?id=${solutionWithReviews.securityReview.id}`,
        icon: 'utility:contact_request',
        statusText: labels.returnedText,
        showIcon: true
      };
    }
    const isRevoked = solutionWithReviews.securityReview.status === PartnerSecurityReviewStatus.revoked;
    return {
      text: labels.securityReviewLinkEdit,
      href: `${SECURITY_REVIEW_EDITOR_ROUTE}?id=${solutionWithReviews.securityReview.id}`,
      icon: isRevoked ? 'utility:edit' : '',
      statusText: isRevoked ? labels.revokedTextSecurityReview : '',
      showIcon: isRevoked ? true : false
    };
  } else if (isFinalState((_solutionWithReviews$3 = solutionWithReviews.securityReviewFeedback) === null || _solutionWithReviews$3 === void 0 ? void 0 : _solutionWithReviews$3.status)) {
    var _solutionWithReviews$4;
    const isPassed = ((_solutionWithReviews$4 = solutionWithReviews.securityReviewFeedback) === null || _solutionWithReviews$4 === void 0 ? void 0 : _solutionWithReviews$4.status) === OpsSecurityOpsReviewStatus.pass;
    return {
      text: isPassed ? labels.showPassedReportLinkStart : labels.showFailedReportLinkStart,
      href: `${SECURITY_REVIEW_EDITOR_ROUTE}?id=${solutionWithReviews.securityReview.id}`,
      icon: isPassed ? 'utility:check' : 'utility:error',
      statusText: isPassed ? labels.passTextSecurityReview : labels.failTextSecurityReview,
      showIcon: true
    };
  } else if (isExpired((_solutionWithReviews$5 = solutionWithReviews.securityReviewFeedback) === null || _solutionWithReviews$5 === void 0 ? void 0 : _solutionWithReviews$5.status)) {
    return {
      text: labels.showPassedReportLinkStart,
      href: `${SECURITY_REVIEW_EDITOR_ROUTE}?id=${solutionWithReviews.securityReview.id}`,
      icon: 'utility:clock',
      statusText: labels.expireSecurityReview,
      showIcon: true
    };
  }
  return {
    text: labels.checkReviewStatusLinkStart,
    href: `${SECURITY_REVIEW_EDITOR_ROUTE}?id=${solutionWithReviews.securityReview.id}`,
    icon: isReturned((_solutionWithReviews$6 = solutionWithReviews.securityReviewFeedback) === null || _solutionWithReviews$6 === void 0 ? void 0 : _solutionWithReviews$6.status) ? 'utility:contact_request' : 'utility:approval',
    statusText: isReturned((_solutionWithReviews$7 = solutionWithReviews.securityReviewFeedback) === null || _solutionWithReviews$7 === void 0 ? void 0 : _solutionWithReviews$7.status) ? labels.returnedText : labels.submittedText,
    showIcon: true
  };
}
export function calculateListingEligibility(solutionWithReviews, labels) {
  var _withVersion$version3, _solutionWithReviews$8;
  const withVersion = solutionWithReviews === null || solutionWithReviews === void 0 ? void 0 : solutionWithReviews.solution;
  if (withVersion !== null && withVersion !== void 0 && (_withVersion$version3 = withVersion.version) !== null && _withVersion$version3 !== void 0 && _withVersion$version3.versionOptionsSecurityReviewed || (solutionWithReviews === null || solutionWithReviews === void 0 ? void 0 : (_solutionWithReviews$8 = solutionWithReviews.securityReviewFeedback) === null || _solutionWithReviews$8 === void 0 ? void 0 : _solutionWithReviews$8.status) === 'Pass - ProdSec') {
    // Solution Version was autoapproved.
    return {
      text: labels.readyToList,
      icon: 'utility:check',
      statusText: '',
      showIcon: true
    };
  }
  return {
    text: labels.securityReviewRequired,
    icon: 'utility:error',
    statusText: '',
    showIcon: true
  };
}